import React from 'react'
import { UseFormRegister, FieldErrors, UseFormSetValue } from 'react-hook-form'
import { US_STATES } from '../../../../site/site-constants'
import { StorageFormValues } from '../config/validationSchema'

interface AddressInfoStepProps {
  register: UseFormRegister<StorageFormValues>
  errors: FieldErrors<StorageFormValues>
  setValue: UseFormSetValue<StorageFormValues>
}

const AddressInfoStep: React.FC<AddressInfoStepProps> = ({
  register,
  errors,
  setValue
}) => {
  return (
    <div style={{ maxWidth: '1000px', margin: '0 auto' }}>
      <div style={{ marginBottom: '1.5rem' }}>
        <label htmlFor="address_line_1" className="forceBlack">Address</label>
        <input
          id="address_line_1"
          placeholder="Address Line"
          type="text"
          {...register('address_line_1')}
          className={errors.address_line_1 ? 'text-input error' : 'text-input'}
        />
        {errors.address_line_1 && <div className="input-feedback">{errors.address_line_1.message}</div>}
      </div>

      <div style={{ marginBottom: '1.5rem' }}>
        <label htmlFor="address_line_2" className="forceBlack">
          Address Line 2 <span style={{ fontSize: 14 }}>(optional)</span>
        </label>
        <input
          id="address_line_2"
          placeholder="Apt or Suite #"
          type="text"
          {...register('address_line_2')}
          className="text-input"
        />
      </div>

      <div style={{ marginBottom: '1.5rem' }}>
        <label className="forceBlack">City & State</label>
        <div style={{ display: 'flex', width: '100%', border: '1px solid #232043', borderRadius: '4px' }}>
          <input
            id="city"
            placeholder="Enter your city"
            type="text"
            {...register('city')}
            style={{
              width: '70%',
              height: 38,
              borderRadius: '4px 0 0 4px',
              border: 'none',
              borderRight: '1px solid #232043',
              padding: '0.5rem',
              fontSize: '16px',
              color: '#232043'
            }}
            className={errors.city ? 'error' : ''}
          />
          <select
            id="state"
            {...register('state')}
            style={{
              width: '30%',
              minWidth: '100px',
              height: 38,
              borderRadius: '0 4px 4px 0',
              border: 'none',
              backgroundColor: 'white',
              color: '#232043',
              fontSize: '16px',
              padding: '0.5rem'
            }}
          >
            <option value="">State</option>
            {Object.keys(US_STATES).map((stCode: string) => (
              <option key={stCode} value={stCode}>{stCode}</option>
            ))}
          </select>
        </div>
        {errors.city && <div className="input-feedback">{errors.city.message}</div>}
        {errors.state && <div className="input-feedback">{errors.state.message}</div>}
      </div>

      <div style={{ marginBottom: '1.5rem' }}>
        <label htmlFor="zip" className="forceBlack">ZIP Code</label>
        <input
          id="zip"
          placeholder="ZIP Code"
          type="text"
          maxLength={10}
          {...register('zip')}
          className={errors.zip ? 'text-input error' : 'text-input'}
        />
        {errors.zip && <div className="input-feedback">{errors.zip.message}</div>}
      </div>

      <div style={{ marginBottom: '1.5rem' }}>
        <label className="forceBlack" style={{ display: 'block', marginBottom: '0.5rem' }}>Driver's License Front</label>
        <input
          id="driver_lic_front"
          name="driver_lic_front"
          className="forceBlack"
          style={{ borderWidth: 1, borderColor: '#232043', width: '100%' }}
          type="file"
          accept="image/*,.pdf"
          onChange={(e) => {
            if (e.target.files && e.target.files[0]) {
              setValue('driver_lic_front', e.target.files[0], { shouldValidate: true })
            }
          }}
          required
        />
        {errors.driver_lic_front && <div className="input-feedback">{errors.driver_lic_front.message as string}</div>}
      </div>

      <div style={{ marginBottom: '1.5rem' }}>
        <label className="forceBlack" style={{ display: 'block', marginBottom: '0.5rem' }}>Driver's License Back</label>
        <input
          id="driver_lic_back"
          name="driver_lic_back"
          className="forceBlack"
          style={{ borderWidth: 1, borderColor: '#232043', width: '100%' }}
          type="file"
          accept="image/*,.pdf"
          onChange={(e) => {
            if (e.target.files && e.target.files[0]) {
              setValue('driver_lic_back', e.target.files[0], { shouldValidate: true })
            }
          }}
          required
        />
        {errors.driver_lic_back && <div className="input-feedback">{errors.driver_lic_back.message as string}</div>}
      </div>
    </div>
  )
}

export default AddressInfoStep
